import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: space-between;
  margin-top: 142px;

  @media (max-width: ${breakPoints.desktop}) {
    margin-top: 53px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    margin-top: 51px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    margin-top: 61px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    flex-direction: column-reverse;
  }
`;

export const Title = styled.div`
  ${FONTS.H2};
  color: ${COLORS.TextWhite};

  @media (max-width: ${breakPoints.sDesktop}) {
    ${FONTS.H3};
  }

  @media (max-width: ${breakPoints.mobile}) {
    text-align: center;
    margin: 0 auto;
    ${FONTS.H4};
  }
`;

export const Description = styled.div`
  ${FONTS.M};
  color: ${COLORS.TextWhite};
  max-width: 480px;

  @media (max-width: ${breakPoints.sDesktop}) {
    ${FONTS.XS};
  }

  @media (max-width: ${breakPoints.mobile}) {
    text-align: center;
    margin: auto 14px;
  }
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 14px;
`;

export const ButtonsBlock = styled.div`
  display: flex;
  column-gap: 27px;
  row-gap: 10px;
  margin-top: 24px;

  @media (max-width: ${breakPoints.desktop}) {
    column-gap: 24px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    column-gap: 17px;
    margin-top: 12px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    column-gap: 14px;
    margin-top: 0;
  }

  @media (max-width: ${breakPoints.mobile}) {
    justify-content: center;
    column-gap: 20px;
    margin: 0 auto;
  }
`;

export const ButtonBlock = styled.div`
  width: auto;

  @media (max-width: ${breakPoints.mobile}) {
    width: 100%;
  }
`;

export const ImageBlock = styled.div`
  display: flex;
  flex-direction: column-reverse;
  max-width: 653px;
  max-height: 362px;
  width: 100%;
  height: 100%;

  @media (max-width: ${breakPoints.desktop}) {
    max-width: 587px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    max-width: 448px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    max-width: 334px;
    margin-bottom: 30px;
  }
`;

export const TvImage = styled.img.attrs({
  src: 'static/images/movix-new/tv-notebook-tablet-mobile.png',
})`
  width: 100%;
`;
